import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CompressedImagePipe } from '../../../../../pipes/compressed-image.pipe';
import { Book } from '../../../../../models/book.model';
import { ShelfType } from '../../../../../services/books.service';
import { AppService } from '../../../../../services/app.service';
import { AsyncPipe, NgOptimizedImage } from '@angular/common';
import { NavigationService } from '../../../../../services/navigation.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-book-shelf-drawer-cover-image',
  templateUrl: './book-shelf-drawer-cover-image.component.html',
  styleUrl: './book-shelf-drawer-cover-image.component.scss',
  imports: [CompressedImagePipe, AsyncPipe, NgOptimizedImage],
})
export class BookShelfDrawerCoverImageComponent {
  // If no book is passed, we display the placeholder value
  // Needed to calculate the height of the swiper shelf
  @Input() book?: Book;
  @Input() type?: ShelfType;
  @Output() imageReady = new EventEmitter<void>();

  constructor(
    public appService: AppService,
    private navigationService: NavigationService,
  ) {}

  goToBook(uuid: string, bookTitle: string): void {
    void this.navigationService.navigate(`/book/${uuid}/details`, { state: { bookTitle } });
  }
}
